import { CalendarDays, MessageSquare, Pencil, Plus, Briefcase } from "lucide-react";
import { motion } from "framer-motion";
import { useRef, useState } from "react";

import { api } from "@/api";
import { Avatar } from "@/components/projects/common";

const STATUSES = ["todo", "doing", "done"];

export function TodoMeta({ todo, members }) {
  const who = members.find((m) => m.id === todo.assignee_id);
  const late = todo.due_date && todo.status !== "done" && todo.due_date < new Date().toISOString().slice(0, 10);
  return (
    <span className="pj-meta">
      {todo.leads?.length > 0 && <span className="pj-client-badge" title={todo.leads.map((l) => l.title).join(", ")} data-testid={`todo-client-badge-${todo.id}`}><Briefcase size={12} />{todo.leads[0].title}{todo.leads.length > 1 && <b>+{todo.leads.length - 1}</b>}</span>}
      {todo.due_date && <span className={late ? "pj-late" : ""}><CalendarDays size={13} />{new Date(todo.due_date).toLocaleDateString("fr-FR", { day: "numeric", month: "short" })}</span>}
      {todo.comments > 0 && <span><MessageSquare size={13} />{todo.comments}</span>}
      {who && <Avatar name={who.name} size={22} />}
    </span>
  );
}

function ColumnTitle({ project, status, onRenamed }) {
  const [edit, setEdit] = useState(false);
  const [value, setValue] = useState(project.columns[status]);
  const save = async () => { setEdit(false); if (value.trim() && value !== project.columns[status]) { await api.patch(`/projects/${project.id}`, { columns: { ...project.columns, [status]: value.trim() } }); onRenamed(); } };
  if (edit) return <input autoFocus className="pj-col-input" value={value} onChange={(e) => setValue(e.target.value)} onBlur={save} onKeyDown={(e) => e.key === "Enter" && save()} data-testid={`kanban-col-input-${status}`} />;
  return <button type="button" className="pj-col-title" onClick={() => setEdit(true)} data-testid={`kanban-col-title-${status}`}>{project.columns[status]}<Pencil size={12} /></button>;
}

export function KanbanBoard({ project, todos, lists, members, onOpen, onMove, onAdd, onRenamed }) {
  const [over, setOver] = useState(null);
  const [draft, setDraft] = useState("");
  const listName = (id) => lists.find((l) => l.id === id)?.name;
  const dragging = useRef(false);
  const colAt = (e) => { const p = e.changedTouches?.[0] || e; return document.elementsFromPoint(p.clientX, p.clientY).find((el) => el.dataset?.col)?.dataset.col || null; };
  const endDrag = (t) => (e) => { const status = colAt(e); setOver(null); setTimeout(() => { dragging.current = false; }, 0); if (status && status !== t.status) onMove(t.id, status); };
  return (
    <div className="pj-kanban" data-testid="kanban-board">
      {STATUSES.map((status) => {
        const cards = todos.filter((t) => t.status === status);
        return (
          <section key={status} data-col={status} className={`pj-col pj-col-${status} ${over === status ? "is-over" : ""}`} data-testid={`kanban-col-${status}`}>
            <header><ColumnTitle project={project} status={status} onRenamed={onRenamed} /><span className="pj-count">{cards.length}</span></header>
            {cards.map((t) => (
              <motion.article key={t.id} drag dragSnapToOrigin dragMomentum={false} whileDrag={{ scale: 1.04, rotate: 2, zIndex: 60, boxShadow: "0 24px 48px rgba(60,30,10,.22)" }} onDragStart={() => { dragging.current = true; }} onDrag={(e) => setOver(colAt(e))} onDragEnd={endDrag(t)} onClick={() => !dragging.current && onOpen(t)} className="pj-card" data-testid={`kanban-card-${t.id}`}>
                {listName(t.list_id) && <small className="pj-card-list">{listName(t.list_id)}</small>}
                <p>{t.title}</p>
                <TodoMeta todo={t} members={members} />
              </motion.article>
            ))}
            {status === "todo" && lists.length > 0 && (
              <form className="pj-card-add" onSubmit={(e) => { e.preventDefault(); if (draft.trim()) { onAdd(draft.trim()); setDraft(""); } }}>
                <Plus size={14} /><input placeholder="Ajouter une tâche" value={draft} onChange={(e) => setDraft(e.target.value)} data-testid="kanban-add-input" />
              </form>
            )}
          </section>
        );
      })}
    </div>
  );
}
